import config from '@packages/config';
import { getEndpoint } from './cmsFetcher';

export const getSurveyEndpoint = (language: string): string =>
  getEndpoint(config.survey.apiEndpoints.bucket, 'active-survey', language);
